/**
  Fields Bindings
  https://foxhound87.github.io/mobx-react-form/docs/bindings/
*/

export default {
  MaterialTextField: {
    disabled: 'disabled',
    error: 'errorText',
    id: 'id',
    label: 'floatingLabelText',
    name: 'name',
    onBlur: 'onBlur',
    onChange: 'onChange',
    onFocus: 'onFocus',
    placeholder: 'hintText',
    type: 'type',
    value: 'value',
  },
};
